import React, { useEffect } from "react";
import Layout from "../../components/Layout.js";
import { WhatsApp } from "@mui/icons-material";
import whatsAppIcone from "../../assets/icons/whatsapp-svgrepo-com (2).svg";
import ServiceCard from "../../components/ServiceCard.js";
import { image } from "framer-motion/client";

const branches = [
  {
    title: "TV Box",
    description:
      "Installation et configuration de votre TV box pour une expérience multimédia optimale.",
      image :"https://rcp.scsstatic.ch/content/dam/assets/b2c/products/tv/help/images/hotspot/desktop/tvbox-tv-verbinden-640x374.png"
  },
  {
    title: "Caméras de Surveillance",
    description:
      "Installation et paramétrage de vos caméras pour sécuriser votre domicile ou entreprise.",
      image :"https://www.quebecmetiersdavenir.com/wp-content/uploads/security-camera-installation-picture-id175397936-3.jpg"

  }
];

const Technique = () => {
  const onSubmit = () => {
    const msg = "Hello, comment pouvons vous aidez ?";
    // const phoneWithCountryCode = "+1234567890"; // Ensure the phone number includes the country code
    if (msg) {
      const url = `https://wa.me/${"+2250585569842"}?text=${encodeURIComponent(
        msg
      )}`;
      window.open(url, "_blank");
    } else {
      alert("Please insert message to send");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll en haut
  }, []);
  return (
    <Layout>
      <section className="relative bg-gradient-to-r from-violet-50 to-orange-50">
        {/* <!-- BG Image --> */}
        <img
          src="https://plus.unsplash.com/premium_photo-1683121696175-d05600fefb85?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt=""
          className="absolute -z-10 inline-block h-full w-full object-cover opacity-75"
        />
        {/* <!-- Container --> */}
        <div className="mx-auto w-full max-w-7xl px-5 py-10 md:px-10 md:py-20 lg:py-30">
          {/* <!-- Component --> */}
          {/* <!-- Image Div --> */}
          <div className="lg:hidden xl:hidden inline-block mb-6">
            <img
              src="https://i.pinimg.com/736x/aa/ca/76/aaca760bdade6c92d11099ca0b1eb22f.jpg"
              alt=""
              classNameName="mx-auto inline-block h-full w-full max-w-[640px] rounded-2xl object-cover"
            />
          </div>
          <div className="grid grid-cols-1 items-center gap-8 sm:gap-20 lg:grid-cols-2">
            {/* <!-- Heading Content --> */}
            <div className="max-w-[720px]">
              <h1 className="mb-3 pb-4 text-4xl font-bold text-green-700 md:text-6xl">
                Connectés et sécurisés
              </h1>
              <p className="mb-6 max-w-[528px] text-xl md:mb-10">
                Optimisez votre connectivité et votre sécurité, le service
                technique qui booste votre quotidien.
              </p>
              <div
                onClick={onSubmit}
                className="flex items-center w-fit cursor-pointer"
              >
                <span className=" flex  gap-x-3   rounded-full bg-primary px-6 py-4 text-center font-bold text-white transition  ">
                  <img
                    src={whatsAppIcone}
                    className="w-5 border-transparent"
                    alt=""
                  />
                  Parlons-en
                </span>
              </div>
            </div>
            {/* <!-- Image Div --> */}
            <div className="lg:inline-block xl:inline-block hidden">
              <img
                src="https://i.pinimg.com/736x/aa/ca/76/aaca760bdade6c92d11099ca0b1eb22f.jpg"
                alt=""
                classNameName="mx-auto inline-block h-full w-full max-w-[640px] rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <ServiceCard
        bannerImage="/path/to/Technique-banner.jpg"
        serviceTitle="Service technique"
        serviceDescription="Nous proposons une gamme complète de services techniques incluant l'installation et la configuration de TV box et la mise en place de caméras de surveillance pour votre sécurité"
        branches={branches}
      />

      {/* <!-- about us --> */}
      <section className="bg-gray-100" id="aboutus">
        <div className="container mx-auto py-16 px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
            <div className="max-w-lg">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
                A propos de nous
              </h2>
              <p className="mt-4 text-gray-600 text-lg">
                Bappa flour mill provides our customers with the highest quality
                products and services. We offer a wide variety of flours and
                spices to choose from, and we are always happy to help our
                customers find the perfect products for their needs. We are
                committed to providing our customers with the best possible
                experience. We offer competitive prices, fast shipping, and
                excellent customer service. We are also happy to answer any
                questions that our customers may have about our products or
                services. If you are looking for a flour and spices service
                business that can provide you with the highest quality products
                and services, then we are the company for you. We look forward
                to serving you!
              </p>
            </div>
            <div className="mt-12 md:mt-0">
              <img
                src="https://images.unsplash.com/photo-1531973576160-7125cd663d86"
                alt="AboutImage"
                className="object-cover rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Add your own content here */}
    </Layout>
  );
};

export default Technique;
